import { render } from "./BilanMaterielDetails.vue?vue&type=template&id=3f4b701a"
import script from "./BilanMaterielDetails.vue?vue&type=script&lang=js"
export * from "./BilanMaterielDetails.vue?vue&type=script&lang=js"

import exportComponent from "/root/dirif/prod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__